import Cardimg from "../img/solar_card-outline.png"
import PlusImg from "../img/plus-icon.png"
import { Box, Button, Typography } from '@mui/material';
import Grid from "@mui/material/Grid"


const Preference = () => {
    return (
        <Grid container spacing={2} sx={{ alignItems: 'center' }}>
            <Grid size={{ md: 6, xs: 12 }}>
                <Box sx={{
                    padding: "30px",
                    borderRadius: "20px",
                    border: "1px solid #e5e5e5",
                    backgroundColor: "#fff",
                    "@media (max-width:600px)": {
                        padding: "10px",
                    },
                }}>
                    <Typography
                        sx={{
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: '14px',
                            fontWeight: 'normal',
                            textAlign: 'left',
                            color: '#717182',
                        }}
                    >
                        Payment Preferences
                    </Typography>
                    <Box sx={{
                        padding: '30px 20px',
                        borderRadius: '8px',
                        border: '1px solid #e5e5e5',
                        marginTop: '15px',
                    }}>
                        <Grid container spacing={2}>
                            <Grid size={{ md: 1, xs: 2 }}>
                                <img src={Cardimg} alt="" style={{ marginTop: '10px', }} />
                            </Grid>
                            <Grid size={{ md: 8, xs: 10 }}>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '14px',
                                    fontWeight: 'normal',
                                    textAlign: 'left',
                                    color: '#0e182b',
                                }}>
                                    **** **** **** 4244
                                </Typography>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '13px',
                                    fontWeight: 'normal',
                                    textAlign: 'left',
                                    color: '#717182',
                                }}>
                                    Expires 12/27
                                </Typography>
                            </Grid>
                            <Grid size={{ md: 3, xs: 12 }} sx={{
                                textAlign: 'end', "@media (max-width:600px)": {
                                    textAlign: 'unset',
                                },
                            }}>
                                <Button variant="outlined" sx={{ textTransform: 'capitalize' }}>Default</Button>
                            </Grid>
                        </Grid>
                    </Box>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Button variant="outlined" sx={{
                            textTransform: 'capitalize', padding: '0 15px',
                            borderRadius: '6px',
                            border: '1px solid #e5e5e5',
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: '14px',
                            textAlign: 'center',
                            color: '#030213',
                            // padding: '7px',
                            width: '100%',
                            marginTop: '15px',
                            marginBottom: '5px',
                        }}><img alt="" src={PlusImg} style={{ marginRight: '10px' }} /> Add Payment Method</Button>
                    </Grid>
                </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }}>
                <Box sx={{
                    padding: "25px 20px",
                    borderRadius: "20px",
                    border: "1px solid #e5e5e5",
                    backgroundColor: "#fff",
                }}>
                    <Typography
                        sx={{
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: '14px',
                            fontWeight: 'normal',
                            textAlign: 'left',
                            color: '#717182',
                            marginBottom: '13px',
                        }}
                    >
                        Notification Settings
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 9, xs: 12 }} sx={{ marginTop: '10px' }}>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                fontStretch: 'normal',
                                textAlign: 'left',
                                color: '#0e182b',
                            }}>Email Notifications</Typography>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '13px',
                                color: '#717182',
                            }}>
                                Booking confirmations & updates
                            </Typography>
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }} sx={{
                            textAlign: 'end', marginTop: '10px', "@media (max-width:600px)": {
                                textAlign: 'unset',
                                marginTop: '0px',
                            },
                        }}>
                            <Button variant="outlined" sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                textAlign: 'center',
                                color: '#030213',
                                borderRadius: '6px',
                                border: '1px solid #e5e5e5',
                                backgroundColor: '#fff',
                                textTransform: 'capitalize',
                            }}>
                                Enabled
                            </Button>
                        </Grid>
                        <Grid size={{ md: 9, xs: 12 }} sx={{ marginTop: '10px' }}>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                fontStretch: 'normal',
                                textAlign: 'left',
                                color: '#0e182b',
                            }}>SMS Notifications</Typography>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '13px',
                                color: '#717182',
                            }}>
                                Important booking alerts
                            </Typography>
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }} sx={{
                            textAlign: 'end', marginTop: '10px', "@media (max-width:600px)": {
                                textAlign: 'unset',
                                marginTop: '0px',
                            },
                        }}>
                            <Button variant="outlined" sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                textAlign: 'center',
                                color: '#030213',
                                borderRadius: '6px',
                                border: '1px solid #e5e5e5',
                                backgroundColor: '#fff',
                                textTransform: 'capitalize',
                            }}>
                                Enabled
                            </Button>
                        </Grid>
                        <Grid size={{ md: 9, xs: 12 }} sx={{ marginTop: '10px' }}>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                fontStretch: 'normal',
                                textAlign: 'left',
                                color: '#0e182b',
                            }}>Push Notifications</Typography>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '13px',
                                color: '#717182',
                            }}>
                                Important booking alerts
                            </Typography>
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }} sx={{
                            textAlign: 'end', marginTop: '10px', "@media (max-width:600px)": {
                                textAlign: 'unset',
                                marginTop: '0px',
                            },
                        }}>
                            <Button variant="outlined" sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                textAlign: 'center',
                                color: '#030213',
                                borderRadius: '6px',
                                border: '1px solid #e5e5e5',
                                backgroundColor: '#fff',
                                textTransform: 'capitalize',
                            }}>
                                Enabled
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    )
}


export default Preference;